<template>
  <div class="info_cull">
    <div class="concept_box">
      <div class="left animate__animated animate__slow animate__fadeInLeft">
        <img :src="CultureInfo.image">
      </div>
      <div class="right animate__animated animate__slow animate__fadeInRight">{{ CultureInfo.info }}</div>
    </div>
    <div class="tow_model_box">
      <div class="left_box">
        <div class="center_l" @mouseenter="leftenter"
             @mouseleave="leftleave">
          <div :class="trapezoidActive == 0 ? 'name1' : 'name'">我们的使命</div>
          <div :class="trapezoidActive == 0 ? '_line1' : '_line'"></div>
          <div :class="trapezoidActive == 0 ? 'info1' : 'info'">
            生命每时每刻，我们用心呵护
            勇于担当，以国民健康为己任，奋斗不息
          </div>
        </div>
      </div>
      <div class="right_box">
        <div class="center_r" @mouseenter="rightenter"
             @mouseleave="rightleave">
          <div :class="trapezoidActive == 1 ? 'name1' : 'name'">我们的愿景</div>
          <div :class="trapezoidActive == 1 ? '_line1' : '_line'"></div>
          <div :class="trapezoidActive == 1 ? 'info1' : 'info'">
            将企业繁荣与百姓健康紧密联系，
            以口碑为基石，做高成长型的“百年企业”
          </div>
        </div>
      </div>
      <div
          :class="trapezoidActive == 0 ? 'left1' : 'left'"
          @mouseenter="leftenter"
          @mouseleave="leftleave"
      ></div>
      <div
          :class="trapezoidActive == 1 ? 'right1' : 'right'"
          @mouseenter="rightenter"
          @mouseleave="rightleave"
      ></div>
    </div>
    <div class="wap_model_box">
        <div class="wap_right"></div>
        <div class="wap_popyu">
          <div class="infO_left">
            <div class="title">我们的使命</div>
            <div class="lines"></div>
            <div class="infos">生命每时每刻，我们用心呵护,勇于担当，以国民健康为己任，奋斗不息</div>
          </div>
          <div class="infO_left infO_right">
            <div class="title">我们的愿景</div>
            <div class="lines"></div>
            <div class="infos">将企业繁荣与百姓健康紧密联系，以口碑为基石，做高成长型的“百年企业”</div>
          </div>
        </div>
    </div>
    <div class="worth">
      <div class="titles_outu">
        <div class="zh">核心价值观</div>
        <div class="line"></div>
      </div>
      <div class="class_worth">
        <div class="box_woeth animate__animated" :class="{'animate__fadeInUp':coreAnmintesto,'animate__faster':index==0,'animate__fast':index==1,'animate__slow':index==3,}" v-for="(item,index) in worthList" :key="index">
          <img :src="item.img">
          <div class="zh">{{ item.zh }}</div>
          <div class="en">{{ item.en }}</div>
        </div>
      </div>
    </div>
    <div class="back_home_tar">
      <div class="box_names animate__animated animate__slow" :class="{'animate__fadeInUp':anmintesto}">
        <div class="titles_info">
          <div>经营理念</div>
          <div class="line"></div>
        </div>
        <div class="info_case">以药效为导向，以口碑为动力——做好人，做好药，做百年品牌</div>
      </div>
    </div>
    <div class="inf_caser_management">
      <div class="management_box">
        <div class="box_county animate__animated animate__slow" :class="{'animate__fadeInUp':ideaAnmintesto}" v-for="(item,index) in CultureInfo.content" :key="index">
          <div class="inf_box">
            <div class="line"></div>
            <div class="zh_mon">{{ item.name }}</div>
            <div class="en_mane">{{ item.en }}</div>
          </div>
          <div class="contents">
            <img :src="item.image">
            <div class="intro">
              <div class="box_infos">{{ item.info }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getCultureInfo} from "../../api/apis";

export default {
  name: "CulturalConcept",
  data() {
    return {
      CultureInfo: {},
      trapezoidActive: -1,
      worthList: [
        {
          img: require("../../assets/AboutImg/one.png"),
          zh: '以人为本',
          en: 'PEOPLE ORIENTED'
        },
        {
          img: require("../../assets/AboutImg/twp.png"),
          zh: '坚持诚信',
          en: 'ADHERE TO INTEGRITY'
        },
        {
          img: require("../../assets/AboutImg/three.png"),
          zh: '力行变革',
          en: 'STRIVE FOR CHANG'
        },
        {
          img: require("../../assets/AboutImg/four.png"),
          zh: '敢为人先',
          en: 'DARE TO BE THE FIRST'
        }
      ],
      anmintesto:false,
      coreAnmintesto:false,
      ideaAnmintesto:false
    }
  },
  created() {
    this.GetCultureInfo()
    window.addEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      let scroll = document.documentElement.scrollTop || document.body.scrollTop;
      console.log(scroll)
      if (document.body.clientWidth < 1200) {

      }else {
        if (scroll > 1780) {
          this.coreAnmintesto = true;
        }
        if (scroll > 2036) {
          this.anmintesto = true;
        }
        if (scroll > 2587) {
          this.ideaAnmintesto = true;
        }
      }
    },
    leftenter() {
      this.trapezoidActive = 0;
    },
    leftleave() {
      this.trapezoidActive = -1;
    },
    rightenter() {
      this.trapezoidActive = 1;
    },
    rightleave() {
      this.trapezoidActive = -1;
    },
    GetCultureInfo() {
      getCultureInfo().then(res => {
        this.CultureInfo = res.data
      })
    },
  }
}
</script>

<style scoped lang="less">
.info_cull {
  width: auto;
  margin-top: 50px;
  .concept_box {
    width: 1200px;
    margin: 0 auto 98px;
    display: flex;
    align-items: center;
    height: 400px;
    overflow: hidden;
    justify-content: space-between;

    .left {
      width: 742px;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .right {
      width: 425px;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 34px;
      color: #666666;
      white-space: pre-wrap;
    }
  }

  .tow_model_box {
    width: 100%;
    height: 619px;
    background-image: url("../../assets/AboutImg/cun_img.png");
    background-size: cover;
    display: flex;
    justify-content: space-between;
    position: relative;

    .left {
      width: 41%;
      height: 0;
      border-top: 616px solid transparent;
      border-right: 350px solid transparent;
      position: absolute;
      left: 0;
      transition: all 0.5s linear;
      z-index: 2;
    }

    .left1 {
      width: 41%;
      height: 0;
      border-top: 619px solid rgba(0, 146, 221, 0.6);
      border-right: 350px solid transparent;
      position: absolute;
      left: 0;
      transition: all 0.5s linear;
    }

    .right {
      width: 41%;
      height: 0;
      border-bottom: 619px solid transparent;
      border-left: 350px solid transparent;
      position: absolute;
      right: 0;
      transition: all 0.5s linear;
      z-index: 2;
    }

    .right1 {
      width: 41%;
      height: 0;
      border-bottom: 619px solid rgba(0, 146, 221, 0.6);
      border-left: 350px solid transparent;
      position: absolute;
      right: 0;
      transition: all 0.5s linear;
    }

    .left_box {
      width: 778px;
      display: flex;
      justify-content: center;
      align-items: center;

      .center_l {
        height: 118px;
        max-width: 80%;
        position: relative;
        z-index: 3;
        transform: translateX(70px);

        .name {
          font-size: 38px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 50px;
          color: #1a1a1a;
          text-align: center;
          transition: all 0.5s;
        }

        .name1 {
          font-size: 38px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 50px;
          color: #fff;
          text-align: center;
          transition: all 0.5s;
        }

        ._line {
          width: 64px;
          height: 4px;
          background: #2c7be5;
          margin: 20px auto;
          transition: all 0.5s;
        }

        ._line1 {
          width: 64px;
          height: 4px;
          background: #fff;
          margin: 20px auto;
          transition: all 0.5s;
        }

        .info {
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 24px;
          color: #666666;
          text-align: center;
          transition: all 0.5s;
        }

        .info1 {
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 24px;
          color: #fff;
          transition: all 0.5s;
          text-align: center;
        }
      }
    }

    .right_box {
      width: 778px;
      display: flex;
      justify-content: center;
      align-items: center;

      .center_r {
        height: 118px;
        max-width: 80%;
        position: relative;
        z-index: 3;
        transform: translateX(-90px);

        .name {
          font-size: 38px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 50px;
          color: #1a1a1a;
          text-align: center;
          transition: all 0.5s;
        }

        .name1 {
          font-size: 38px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 50px;
          color: #fff;
          text-align: center;
          transition: all 0.5s;
        }

        ._line {
          width: 64px;
          height: 4px;
          background: #2c7be5;
          margin: 20px auto;
          transition: all 0.5s;
        }

        ._line1 {
          width: 64px;
          height: 4px;
          background: #fff;
          margin: 20px auto;
          transition: all 0.5s;
        }

        .info {
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 24px;
          color: #666666;
          text-align: center;
          transition: all 0.5s;
        }

        .info1 {
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 24px;
          color: #fff;
          transition: all 0.5s;
          text-align: center;
        }
      }
    }
  }
  .wap_model_box{
    display: none;
  }

  .worth {
    width: 1142px;
    margin: 70px auto 120px;

    .titles_outu {
      width: 210px;
      margin: 0 auto;
      text-align: center;
      font-size: 38px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 50px;
      color: #1A1A1A;

      .line {
        width: 64px;
        height: 4px;
        background: #2C7BE5;
        margin: 20px auto 0;
      }
    }

    .class_worth {
      display: flex;
      justify-content: space-between;
      margin-top: 60px;

      .box_woeth {
        width: 222px;
        height: 275px;
        background: #FFFFFF;
        text-align: center;
        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
        opacity: 0;
        img {
          width: 110px;
          height: 110px;
          margin-top: 50px;
        }

        .zh {
          font-size: 22px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #333333;
          margin: 18px auto 14px;
        }

        .en {
          font-size: 18px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #D1D1D1;
        }
      }

      .animate__fadeInUp{
        opacity: 1;
      }

      .box_woeth:hover {
        .zh {
          color: #0092DD;
        }
      }
    }
  }

  .back_home_tar {
    width: 100%;
    height: 258px;
    background-image: url("../../assets/AboutImg/clouds.png");
    background-size: cover;
    padding-top: 0.1px;
    overflow: hidden;
    .box_names {
      width: 1200px;
      margin: 33px auto 0;
      opacity: 0;
      .titles_info {
        font-size: 38px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        text-align: center;

        .line {
          width: 64px;
          height: 4px;
          background: #2C7BE5;
          margin: 20px auto 0;
        }
      }

      .info_case {
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        text-align: center;
        margin-top: 48px;
      }
    }
    .animate__fadeInUp{
      opacity: 1;
    }
  }

  .inf_caser_management {
    margin: 80px auto 180px;
    width: 1200px;

    .management_box {
      display: flex;

      .box_county {
        opacity: 0;
        width: 372px;
        min-height: 372px;
        background: #FFFFFF;
        box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
        margin-right: 40px;
        overflow: hidden;
        .inf_box {
          padding: 0 20px;

          .line {
            width: 40px;
            height: 1px;
            background: #2C7BE5;
            margin-top: 34px;
            transition: all 0.3s linear;
          }

          .zh_mon {
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #1A1A1A;
            margin: 23px auto 20px;
          }

          .en_mane {
            font-size: 12px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #666666;
            margin-bottom: 34px;
          }
        }

        .contents {
          width: 372px;
          height: 230px;
          position: relative;

          img {
            width: 100%;
            height: 100%;
          }

          .intro {
            position: absolute;
            bottom: -240px;
            width: 100%;
            transition: all 0.3s linear;
            height: 100%;
            background: rgba(0, 0, 0, 0.6);
            display: flex;
            align-items: center;
            justify-content: center;
            .box_infos{
              width: 264px;
              height: 148px;
              font-size: 15px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              line-height: 30px;
              color: #FFFFFF;
              overflow: hidden;
              white-space: pre-wrap;
              text-align: center;
            }
          }
        }
      }

      .box_county:nth-child(3n) {
        margin-right: 0;
      }
      .box_county:hover{
        .inf_box{
          .line{
            width: 100%;
          }
        }
         .contents{
           .intro{
             bottom: 0;
           }
         }
      }
    }
  }

}

@media (max-width: 1200px) {
  .info_cull {
    width: auto;
    margin-top: 15px;

    .concept_box {
      width: 100%;
      margin: 0 auto 25px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      height: auto;
      overflow: hidden;
      justify-content: space-between;
      .left {
        width: 100%;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .right {
        text-align: center;
        padding:0.1px 15px 0;
        margin-top: 16px;
        width: auto;
        font-size: 12px;
        line-height: 16px;
        white-space: pre-wrap;
      }
    }

    .tow_model_box {
      display: none;
    }
    .wap_model_box{
      display: block;
      background-image: url("../../assets/AboutImg/cun_img.png");
      background-size: cover;
      width: 100%;
      height: 310px;
      position: relative;
      .wap_right{
        background-image: url("../../assets/AboutImg/img_uop.png");
        background-size: cover;
        width:292px;
        height: 310px;
        position: absolute;
        right: 0;
      }
      .wap_popyu{
        padding:0 15px;
        position: relative;
        .infO_left{
          width: 162px;
          position: absolute;
          text-align: center;
          top: 49px;
          .title{
            font-size: 19px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #1A1A1A;
          }
          .lines{
            width: 32px;
            height: 2px;
            background: #2C7BE5;
            margin: 10px auto;
          }
          .infos{
            font-size: 9px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #666666;
          }
        }
        .infO_right{
          width: 171px;
          top: 180px;
          right: 15px;
          .title,.infos{
            color: #FFFFFF;
          }
          .lines{
            background: #FFFFFF;
          }
        }
      }
    }

    .worth {
      width: auto;
      //width: 1142px;
      margin: 30px auto 35px;

      .titles_outu {
        width: 210px;
        margin: 0 auto;
        text-align: center;
        font-size: 19px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 25px;
        color: #1A1A1A;
        .line {
          width: 32px;
          height: 2px;
          background: #2C7BE5;
          margin: 10px auto 0;
        }
      }

      .class_worth {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        margin-top: 25px;
        padding: 0 15px;
        .box_woeth {
          opacity: 1;
          //width: 162px;
          width: 46%;
          height: 200px;
          background: #FFFFFF;
          text-align: center;
          box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
          margin-bottom: 22px;
          img {
            width: 80px;
            height: 80px;
            margin-top: 37px;
          }
          .zh {
            font-size: 15px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #333333;
            margin: 12px auto 7px;
          }
          .en {
            font-size: 13px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #D1D1D1;
          }
        }

        .box_woeth:hover {
          .zh {
            color: #0092DD;
          }
        }
      }
    }

    .back_home_tar {
      width: 100%;
      height: 129px;
      background-image: url("../../assets/AboutImg/clouds.png");
      background-size: cover;
      padding-top: 0.1px;

      .box_names {
        width: auto;
        opacity: 1;
        margin: 14px auto 0;

        .titles_info {
          font-size: 19px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #666666;
          text-align: center;

          .line {
            width: 32px;
            height: 2px;
            background: #2C7BE5;
            margin: 10px auto 0;
          }
        }

        .info_case {
          padding: 0 21px;
          font-size: 13px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #666666;
          text-align: center;
          margin-top: 20px;
        }
      }

    }

    .inf_caser_management {
      margin: 15px auto 50px;
      width: auto;
      overflow: hidden;
      .management_box {
        display: flex;
        flex-wrap: wrap;
        padding:0 15px;
        .box_county {
          opacity: 1;
          width: 100%;
          min-height: 345px;
          background: #FFFFFF;
          box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
          margin-right:0;
          overflow: hidden;
          margin-bottom: 15px;
          .inf_box {
            padding: 0 19px;
            .line {
              width: 37px;
              height: 1px;
              background: #2C7BE5;
              margin-top: 32px;
              transition: all 0.3s linear;
            }

            .zh_mon {
              font-size: 17px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #1A1A1A;
              margin: 22px auto 9px;
            }
            .en_mane {
              font-size: 12px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #666666;
              margin-bottom: 31px;
            }
          }

          .contents {
            width: 100%;
            height: 214px;
            position: relative;
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }

            .intro {
              position: absolute;
              bottom: 0;
              width: 100%;
              transition: all 0.3s linear;
              height: 100%;
              background: rgba(0, 0, 0, 0.6);
              display: flex;
              align-items: center;
              justify-content: center;
              .box_infos{
                width: 245px;
                height: 96px;
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                line-height: 20px;
                color: #FFFFFF;
                overflow: hidden;
              }
            }
          }
        }

        .box_county:nth-child(3n) {
          margin-right: 0;
        }
      }
    }

  }
}

@media screen and (min-width:414px) and (max-width:1200px){
  .info_cull .wap_model_box .wap_right{
    width: 60%;
  }
  .info_cull .wap_model_box .wap_popyu .infO_left{
        left: 25%;
    transform: translateX(-50%);
  }
  .info_cull .wap_model_box .wap_popyu .infO_right{
    left: auto;
    right: 8%;
  }
}
@media screen and (min-width:469px) and (max-width:840px){
  .info_cull .wap_model_box .wap_popyu .infO_right{
    left: auto;
    right: 0%;
  }
}
@media screen and (min-width:414px) and (max-width:469px){
  .info_cull .wap_model_box .wap_popyu .infO_right{
    left: auto;
    right: -16%;
  }
}

@media screen and (min-width:1200px) and (max-width:1700px){
  .info_cull .tow_model_box .left_box .center_l{
    max-width: 55%;
  }
  .info_cull .tow_model_box .right_box .center_r{
    max-width: 55%;
  }
}
@media screen and (min-width:1277px) and (max-width:1700px){
  .info_cull .tow_model_box .left_box .center_l{
    max-width: 55%;
  }
  .info_cull .tow_model_box .right_box .center_r{
    max-width: 55%;
  }
  .info_cull .tow_model_box .right{
    width: 40%;
  }
  .info_cull .tow_model_box .left{
    width: 40%;
  }
  .info_cull .tow_model_box .right1{
    width: 40%;
  }
  .info_cull .tow_model_box .left1{
    width: 40%;
  }
}
@media screen and (min-width:1200px) and (max-width:1277px){

  .info_cull .tow_model_box .right{
    width: 36%;
  }
  .info_cull .tow_model_box .left{
    width: 36%;
  }
  .info_cull .tow_model_box .right1{
    width: 36%;
  }
  .info_cull .tow_model_box .left1{
    width: 36%;
  }
}
</style>